import { useExperienceModuleContext } from 'modules/experience-core';
import { ExperienceEntityType, NavigationItem } from 'modules/experience-core';

import { ACCESS_MANAGEMENT_NAVIGATION_ITEM, CAMPAIGNS_NAVIGATION_ITEM, INSIGHTS_NAVIGATION_ITEM } from '../constants';

export const useBusinessNavigationItems = (): NavigationItem[] => {
  const {
    experienceEntity: { experienceEntityType },
  } = useExperienceModuleContext();

  // Begin TODO: Implement logic to determine if navigation should be shown
  const shouldShowInsightsNavigation = true;
  const shouldShowAccessManagementNavigation = true;
  const shouldShowCampaignNavigation = experienceEntityType === ExperienceEntityType.MERCHANT;
  // Begin TODO: Implement logic to determine if navigation should be shown

  return [
    ...(shouldShowInsightsNavigation ? [INSIGHTS_NAVIGATION_ITEM] : []),
    ...(shouldShowAccessManagementNavigation ? [ACCESS_MANAGEMENT_NAVIGATION_ITEM] : []),
    ...(shouldShowCampaignNavigation ? [CAMPAIGNS_NAVIGATION_ITEM] : []),
  ];
};
